import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  previewTitle: {
    defaultMessage: 'Template Preview',
    description: 'Title for the packing slip template preview section',
    id: 'GFZTCG',
  },
  sampleDataNote: {
    defaultMessage: 'Preview shows sample data. Field placeholders will be replaced with actual order data when printed.',
    description: 'Note explaining that preview uses sample data',
    id: 'Ryg2UX',
  },
  loadError: {
    defaultMessage: 'Unable to load PDF preview. Please try again.',
    description: 'Error message when PDF preview fails to load',
    id: 'xAiSsa',
  },
});
